import React from 'react';
import styled from '@emotion/styled';
import Tooltip from './Tooltip';

const StatusContainer = styled.div`
  position: relative;
  cursor: help;
  :hover > div {
    display: block;
  }
  span {
    padding-left: 20px;
    padding-right: 20px;
    height: 25px;
    line-height: 25px;
    color: white;
    display: inline-block;
    font-size: 14px;
    border-radius: 6px;
    background-color: ${(props: any) => `rgba(${props.statusColorRgba[0]}, ${props.statusColorRgba[1]}, ${ props.statusColorRgba[2]}, .1)`};
    border-color: ${(props: any) => props.statusColorHex};
    color: ${(props: any) => props.statusColorHex};
    border-style: solid;
    border-width: 1px;
    font-weight: 500;
  }
`;

interface ItemStatusProps {
  status: string;
  statusDescription: string;
  statusColorHex: string;
  statusColorRgba: [number];
}

const ItemStatus: React.FC<ItemStatusProps> = ({
  status,
  statusDescription,
  statusColorHex,
  statusColorRgba
}) => {
  return (
    <StatusContainer
      statusColorRgba={statusColorRgba}
      statusColorHex={statusColorHex}
    >
      <Tooltip title={status} description={statusDescription} />
      <span>
        {status}
      </span>
    </StatusContainer>
  );
};

export default ItemStatus;






